<template>
  <div class="player-avatar">
    <div class="player-avatar__background"></div>

    <div class="player-avatar__container" v-if="id && id !== 'UNKNOWN'">
      <div
        class="player-avatar__avatar"
        v-if="id !== 'MINION'"
        :style="{ backgroundImage: getRoleImage(id) }"
      ></div>

      <div class="player-avatar__minion" v-if="team === 'MINIONS'"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      id: { type: String, default: 'UNKNOWN' },
      team: { type: String },
    },
    methods: {
      getRoleImage(roleIdRaw) {
        const roleIdKebab = roleIdRaw.toLowerCase().replace('_', '-');

        const imageUrl = require(`../assets/img/characters/${roleIdKebab}.png`);

        return `url(${imageUrl})`;
      },
    },
  };
</script>

<style lang="scss">
  .player-avatar {
    position: relative;
    padding: 24px 24px;
    width: 100%;
    height: 100%;
    border-radius: 50%;

    &__background {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) translateZ(0);
      //
      width: 100%;
      height: 100%;
      //
      background: url(../assets/img/game/avatar-frame.png) center no-repeat;
      background-size: contain;
      transition: opacity 200ms;
    }

    &__container {
      height: 100%;
      width: 100%;
      transition: opacity 200ms;
      //
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%) translateZ(0);
    }

    &__avatar,
    &__minion {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      //
      transition: opacity 400ms;
      background: no-repeat center;
      background-size: contain;
    }

    &__avatar {
      width: 70%;
      height: 70%;
    }

    &__minion {
      width: 79%;
      height: 79%;
      border-radius: 50%;
      box-shadow: inset 0 0 4px 4px rgba(255, 0, 0, 0.6);
    }
  }
</style>
